module.exports = __webpack_public_path__ + "img/img-general-report.34d9d313.png";